import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { HelpCenter } from "@/components/help/HelpCenter";

export default function Help() {
	const { t } = useTranslation();
	usePageTitle(t("help.pageTitle"));

	return (
		<div className="p-6 lg:p-8">
			<HelpCenter />
		</div>
	);
}
